import { render } from "./Privacy.vue?vue&type=template&id=da1ea3ba&scoped=true&ts=true"
import script from "./Privacy.vue?vue&type=script&lang=ts"
export * from "./Privacy.vue?vue&type=script&lang=ts"

import "./Privacy.vue?vue&type=style&index=0&id=da1ea3ba&scoped=true&lang=scss"

import exportComponent from "/home/build/jenkins/workdir/workspace/fast-build/fast-build/67161/vshow-main/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da1ea3ba"]])

export default __exports__